import updateCartCount from "helpers/update-cart/updateCartCount";
import updateWishlistCount from "helpers/update-wishlist/updateWishlistCount";
import {
  isTouch,
  getViewportSize,
  breakPoints,
  isMobile,
} from "helpers/global-variables/globalVariables";
import debounce from "helpers/debounce/debounce";

export default () => {
  // List with elements related to the menu
  const MenuSelectors = {
    headerParent: "#main-header-container",
    headerContent: ".header-content",
    menuTrigger: ".menu-trigger",
    mobileMenuTrigger: ".mobile-menu-trigger",
    mobileSearchTrigger: ".search-trigger",
    menuWrapper: "#main-navigation",
    mainMenuContainer: ".main-menu-container",
    menuPosition: ".menu-content-position",
    mainMenuItem: ".main-menu-name",
    menuViewer: ".menu-viewer",
    subMenu: ".sub-menu",
    menuShade: ".shade",
    menuBackBtn: ".move-backwards",
    searchInput: "#searchfield",
    topBanner: ".top-banner",
    topBannerCloseBtn: ".top-banner .btn-close",
    companyRatingBanner: ".global-company-rating",
  };

  //Set global current open menu id var
  let currentOpenMenuId = "";

  /*-----------------------------Add event listeners ------------------------------*/
  const loadEventListeners = function () {
    document.addEventListener("click", (e) => {
      if (e.target.closest(MenuSelectors.menuTrigger)) {
        toggleMenu();
      }
    });

    if (document.querySelector(MenuSelectors.mainMenuContainer)) {
      //Menu item mouse enter event
      document
        .querySelector(MenuSelectors.mainMenuContainer)
        .addEventListener("mouseover", function (e) {
          toggleSubmenu(e);
        });
    }

    if (document.querySelector(MenuSelectors.menuViewer)) {
      //Menu mouse out event to close all
      document
        .querySelector(MenuSelectors.menuViewer)
        .addEventListener("mouseleave", function () {
          //This should only happen when using the static navigation on homepage. Check if headerParent already has a menu state. If not close on mouse out.
          if (
            !document
              .querySelector(MenuSelectors.headerParent)
              .hasAttribute("data-menu-state") ||
            document
              .querySelector(MenuSelectors.headerParent)
              .getAttribute("data-menu-state") === "close"
          ) {
            closeAll();
          }
        });
    }

    if (document.querySelector(MenuSelectors.menuShade)) {
      //Click on shade to close all
      document
        .querySelector(MenuSelectors.menuShade)
        .addEventListener("click", closeAll);
    }

    if (document.querySelector(MenuSelectors.menuWrapper)) {
      //Click on menuwrapper to close all
      document
        .querySelector(MenuSelectors.menuWrapper)
        .addEventListener("click", function (e) {
          //Check if the click is on the menu wrapper and not on it's children.
          if (e.target.id === "main-navigation") {
            closeAll();
          }
        });
    }

    //Event specific for touch devices (mobile/tablet)
    //Click on main menu item to open submenu
    if (document.querySelector(MenuSelectors.mainMenuContainer)) {
      document
        .querySelector(MenuSelectors.mainMenuContainer)
        .addEventListener("click", function (e) {
          if (isTouch() || getViewportSize().w < breakPoints.md) {
            toggleSubmenu(e);
          }
        });
    }

    //Click on back button in mobile menu
    if (document.querySelector(MenuSelectors.menuBackBtn)) {
      document
        .querySelector(MenuSelectors.menuBackBtn)
        .addEventListener("click", function (e) {
          e.preventDefault();
          toggleMobileMenuView("main");
        });
    }

    //Click on menu button in mobile menu
    if (
      document.querySelectorAll(MenuSelectors.mobileMenuTrigger).length !== 0
    ) {
      document
        .querySelectorAll(MenuSelectors.mobileMenuTrigger)
        .forEach((trigger) => {
          trigger.addEventListener("click", () => {
            toggleMenu(trigger.getAttribute("data-header-btn"));
          });
        });
    }
    //Click on mobile search button
    if (document.querySelectorAll(MenuSelectors.mobileSearchTrigger)) {
      document
        .querySelectorAll(MenuSelectors.mobileSearchTrigger)
        .forEach((trigger) => {
          trigger.addEventListener("click", function (e) {
            e.preventDefault();
            toggleMobileSearch();
          });
        });
    }
  };

  /*-----------------------------Toggle main navigation------------------------------*/
  const toggleMenu = function () {
    const headerParent = document.querySelector(MenuSelectors.headerParent);
    const menuState = headerParent.getAttribute("data-menu-state");

    //Always close search
    toggleMobileSearch("close");
    if (menuState !== "open") {
      //Opens the menu and show shade
      headerParent.setAttribute("data-menu-state", "open");
      document.querySelector("body").setAttribute("data-menu-state", "open");

      //Remove scroll on body when mobile menu is opened
      if (isTouch() || getViewportSize().w < breakPoints.md) {
        document.querySelector("body").setAttribute("data-scroll", "no-scroll");
      }
    } else {
      // Hide menu and hide shade
      headerParent.setAttribute("data-menu-state", "close");
      document.querySelector("body").setAttribute("data-menu-state", "close");
      //Add scroll to body when mobile menu is closed
      if (isTouch() || getViewportSize().w < breakPoints.md) {
        document.querySelector("body").setAttribute("data-scroll", "scroll");
      }
    }
  };

  /*-----------------------------Toggle sub navigation------------------------------*/
  const toggleSubmenu = function (e) {
    let mainMenuItem = "";
    if (e.target.closest(".main-menu-name") !== null) {
      mainMenuItem = e.target.closest(".main-menu-name");
    }
    if (e.target.className === "main-menu-name") {
      mainMenuItem = e.target;
    }

    // Check if mouse over is a menu item
    if (mainMenuItem) {
      const menuId = mainMenuItem.parentElement.getAttribute("data-menu-id");

      //Check if menu item has menu ID to open submenu
      if (menuId) {
        e.preventDefault();
        //Set menu item active / inactive
        if (mainMenuItem.getAttribute("data-active") !== "true") {
          //Set other item inactive
          if (
            document.querySelector(
              MenuSelectors.mainMenuItem + '[data-active="true"]',
            )
          ) {
            document
              .querySelector(
                MenuSelectors.mainMenuItem + '[data-active="true"]',
              )
              .setAttribute("data-active", "false");
          }
          //Add active to current menu item
          mainMenuItem.setAttribute("data-active", "true");
        }

        document
          .querySelector(MenuSelectors.menuWrapper)
          .setAttribute("data-menu-view", "sub");

        const currentOpenSub = document.querySelector(
          MenuSelectors.subMenu + '[data-menu-state="open"]',
        );
        //Check if there is a different menu selected and check if there is a submenu currently open
        if (currentOpenMenuId !== menuId && currentOpenSub) {
          currentOpenSub.removeAttribute("data-menu-state");
        }

        //Get correct submenu item
        const subMenuItem = document.querySelector(
          MenuSelectors.subMenu + '[data-menu-id= "' + menuId + '"]',
        );

        //Get parent and set state
        subMenuItem.parentElement.setAttribute("data-menu-state", "open");

        //Set state of current submenu
        subMenuItem.setAttribute("data-menu-state", "open");

        //Set current open menu id
        currentOpenMenuId = menuId;

        //Set mobile menu view to sub
        toggleMobileMenuView("sub");
      }
    }
  };

  /*-----------------------------Close all open elements------------------------------*/
  const closeAll = function () {
    //Get all elements to close
    const elementsToClose = document.querySelectorAll(
      '[data-menu-state="open"]',
    );

    //Loop through all elements and set state to close
    for (let i = 0; i < elementsToClose.length; ++i) {
      elementsToClose[i].setAttribute("data-menu-state", "close");
    }

    if (
      document.querySelector(
        MenuSelectors.mainMenuItem + '[data-active="true"]',
      )
    ) {
      document
        .querySelector(MenuSelectors.mainMenuItem + '[data-active="true"]')
        .setAttribute("data-active", "false");
    }

    //Just in case set the mobile view to main
    toggleMobileMenuView("main");
    document
      .querySelector(MenuSelectors.menuWrapper)
      .setAttribute("data-menu-view", "main");

    //Just in case add scroll to body on mobile
    if (isTouch() || getViewportSize().w < breakPoints.md) {
      document.querySelector("body").setAttribute("data-scroll", "scroll");
    }
  };

  /*-----------------------------Toggle mobile menu view------------------------------*/
  const toggleMobileMenuView = function (view) {
    document
      .querySelector(MenuSelectors.menuPosition)
      .setAttribute("data-menu-view", view);

    //Close submenu
    if (
      view === "main" &&
      document.querySelector(MenuSelectors.subMenu + '[data-menu-state="open"]')
    ) {
      document
        .querySelector(MenuSelectors.subMenu + '[data-menu-state="open"]')
        .setAttribute("data-menu-state", "close");
      document
        .querySelector(MenuSelectors.subMenu)
        .parentElement.setAttribute("data-menu-state", "close");
    }
  };
  /*-----------------------------Toggle mobile search when clicked on search button------------------------------*/
  const toggleMobileSearch = function (state) {
    const searchActive = document
      .querySelector(MenuSelectors.headerParent)
      .getAttribute("data-search-active");

    //Check if search screen is already open or not
    if (searchActive && searchActive === "false" && state !== "close") {
      //Close all menu related items
      closeAll();
      //Open search screen
      document
        .querySelector(MenuSelectors.headerParent)
        .setAttribute("data-search-active", "true");

      //Remove scroll on body when mobile menu is opened
      if (isTouch() || getViewportSize().w < breakPoints.md) {
        document.querySelector("body").setAttribute("data-scroll", "no-scroll");
      }

      //Focus on input
      document.querySelector(MenuSelectors.searchInput).focus();
    } else {
      document
        .querySelector(MenuSelectors.headerParent)
        .setAttribute("data-search-active", "false");

      //Remove scroll on body when mobile menu is opened
      if (isTouch() || getViewportSize().w < breakPoints.md) {
        document.querySelector("body").setAttribute("data-scroll", "scroll");
      }
    }

    // hide search on scroll
    window.addEventListener(
      "scroll",
      debounce(() => {
        document
          .querySelector(MenuSelectors.headerParent)
          .setAttribute("data-search-active", "false");
      }, 300),
    );
  };

  const checkIfMobile = () => {
    if (isMobile()) {
      const mainMenuContainer = document.querySelector(".main-menu-container");
      if (mainMenuContainer) {
        mainMenuContainer.classList.add("mobile");
      }
    }
  };

  /*-----------------------------Public methods------------------------------*/
  return {
    init: function () {
      //Initialize event listeners
      loadEventListeners();
      checkIfMobile();
    },
  };
};
